/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
require('./src/components/custom.css')
require('./src/components/tailwind.css')

const WrapWithProvider = require('./src/helpers/wrap-with-provider').default
const { injectSpeedInsights } = require('@vercel/speed-insights')

// require('./src/components/global.scss')

const { setConfiguration } = require('react-grid-system')
setConfiguration({ maxScreenClass: 'xl' })

exports.shouldUpdateScroll = ({ routerProps }) => {
  const disableScrollUpdate = routerProps?.location?.state?.disableScrollUpdate
  return !disableScrollUpdate
}

exports.wrapRootElement = WrapWithProvider

// Inject Speed Insights on browser load
exports.onClientEntry = () => {
  injectSpeedInsights()
}


